import firebaseConfig from "./config/firebaseConfig";
import  {initializeApp} from "firebase/app";
import  {getAuth} from "firebase/auth";
import {getFirestore} from "firebase/firestore";


//This is the variable which acts an entry point between our project and firebase
const firebaseApp = initializeApp(firebaseConfig);

// Authentication and database
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

export {auth,db};